import { render, staticRenderFns } from "./InstitutionalPageSyncButton.vue?vue&type=template&id=6ee499d7&scoped=true"
import script from "./InstitutionalPageSyncButton.vue?vue&type=script&lang=js"
export * from "./InstitutionalPageSyncButton.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalPageSyncButton.vue?vue&type=style&index=0&id=6ee499d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee499d7",
  null
  
)

export default component.exports